import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ContactCTA = () => {
  return (
    <section
      data-testid="contact-cta-section"
      className="relative py-24 md:py-32 border-t border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#00F0FF]/10 blur-[120px] pointer-events-none" />

      <div className="container-x relative">
        <div className="max-w-4xl">
          <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
            / Ready when you are
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.05]">
            Have a hard problem?{" "}
            <span className="text-[#00F0FF]">We&apos;d like to hear about it.</span>
          </h2>
          <p className="mt-6 text-white/60 max-w-2xl leading-relaxed text-lg">
            Tell us what you&apos;re building. We&apos;ll respond within 24 hours with a
            senior engineer or partner on the thread — never a sales rep.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-start-project"
              className="inline-flex items-center gap-2 rounded-full bg-[#00F0FF] text-black font-semibold px-6 py-3.5 transition-transform duration-200 hover:-translate-y-0.5 hover-glow"
            >
              Start a conversation <ArrowRight size={16} />
            </Link>
            <a
              href="mailto:contact@pransam.com"
              data-testid="cta-email"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 text-white/90 px-6 py-3.5 transition-colors duration-200 hover:bg-white/10"
            >
              contact@pransam.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
